import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.31192 4.31217C5.95292 2.67117 8.17859 1.74927 10.4993 1.74927C12.82 1.74927 15.0457 2.67117 16.6867 4.31217C18.3277 5.95316 19.2496 8.17883 19.2496 10.4995C19.2496 12.3995 18.6317 14.2358 17.5071 15.7396L21.8837 20.1162C22.3718 20.6043 22.3718 21.3958 21.8837 21.8839C21.3955 22.3721 20.6041 22.3721 20.1159 21.8839L15.7394 17.5074C14.2355 18.6319 12.3993 19.2498 10.4993 19.2498C8.17859 19.2498 5.95292 18.3279 4.31192 16.6869C2.67093 15.0459 1.74902 12.8203 1.74902 10.4995C1.74902 8.17883 2.67093 5.95316 4.31192 4.31217ZM10.4993 4.24927C8.84163 4.24927 7.25184 4.90778 6.07969 6.07993C4.90753 7.25209 4.24902 8.84187 4.24902 10.4995C4.24902 12.1572 4.90753 13.747 6.07969 14.9192C7.25184 16.0913 8.84163 16.7498 10.4993 16.7498C12.157 16.7498 13.7468 16.0913 14.9189 14.9192C16.0911 13.747 16.7496 12.1572 16.7496 10.4995C16.7496 8.84187 16.0911 7.25209 14.9189 6.07993C13.7468 4.90778 12.157 4.24927 10.4993 4.24927Z"
        fill={colorValue}
      />
    </svg>
  );
};
